export default __webpack_public_path__ + "static/media/backgroundMobile.21879e01.png";